






























































































































































































































































































import Modal from "@/components/custom/modal/Modal.vue";
import useInvoiceAR from "@/hooks/useInvoiceAR";
import { EnumInvoiceArStatus } from "@/models/enums/invoice.enum";
import {
  InvoiceRecurringReportContract,
  InvoiceRecurringReportLine,
  InvoiceRecurringReportResponseDto,
} from "@/models/interface/invoice-recurring-report/InvoiceRecurringReportResponseDto.interface";
import { currencyFormat } from "@/validator/globalvalidator";
import Vue from "vue";
import { DynamicScroller, DynamicScrollerItem } from "vue-virtual-scroller";
import { Prop } from "vue/types/options";
import InvoiceRecurringReportDetailField from "./InvoiceRecurringReportDetailField.vue";
import InvoiceRecurringReportTableContractSkeleton from "./InvoiceRecurringReportTableContractSkeleton.vue";
import InvoiceRecurringReportTableCustomerSkeleton from "./InvoiceRecurringReportTableCustomerSkeleton.vue";
import InvoiceRecurringReportTableRowSkeleton from "./InvoiceRecurringReportTableRowSkeleton.vue";
import InvoiceRecurringReportTableSubTotalSkeleton from "./InvoiceRecurringReportTableSubTotalSkeleton.vue";

type RecurringReportData =
  | {
      id: string;
      type: "customer";
      customer: InvoiceRecurringReportResponseDto;
    }
  | { id: string; type: "contract"; contract: InvoiceRecurringReportContract }
  | { id: string; type: "line"; line: InvoiceRecurringReportLine }
  | { id: string; type: "subtotal"; contract: InvoiceRecurringReportContract };

export default Vue.extend({
  name: "InvoiceRecurringReportTable",
  components: {
    Modal,
    DynamicScroller,
    DynamicScrollerItem,
    InvoiceRecurringReportTableCustomerSkeleton,
    InvoiceRecurringReportTableContractSkeleton,
    InvoiceRecurringReportTableRowSkeleton,
    InvoiceRecurringReportTableSubTotalSkeleton,
    InvoiceRecurringReportDetailField,
  },
  props: {
    invoiceRecurringReports: {
      required: true,
      type: Array as Prop<InvoiceRecurringReportResponseDto[]>,
      default: (): InvoiceRecurringReportResponseDto[] => [],
    },
    loading: {
      required: true,
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      collapsedCustomers: [] as string[],
      collapsedIcs: [] as string[],
      show: {
        detailInvoice: false,
      },
      loadingDetail: false,
      detailData: {},
    };
  },

  computed: {
    flattenedRows(): RecurringReportData[] {
      const rows: RecurringReportData[] = [];

      this.invoiceRecurringReports.forEach(customer => {
        rows.push({
          id: `customer-${customer.customerId}`,
          type: "customer",
          customer,
        });

        if (this.collapsedCustomers.includes(customer.customerName)) {
          return;
        }

        customer.contracts.forEach(contract => {
          rows.push({
            id: `contract-${contract.icNo}`,
            type: "contract",
            contract,
          });

          if (this.collapsedIcs.includes(contract.icNo)) {
            return;
          }

          contract.lines.forEach(line => {
            rows.push({
              id: `line-${contract.icNo}-${line.no}`,
              type: "line",
              line,
            });
          });

          rows.push({
            id: `subtotal-${contract.icNo}`,
            type: "subtotal",
            contract,
          });
        });
      });

      return rows;
    },
    columnsTableDetail() {
      return [
        {
          title: this.$t("lbl_unit"),
          dataIndex: "unit",
          key: "unit",
          width: 25,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_description"),
          dataIndex: "description",
          key: "description",
          width: 100,
          scopedSlots: { customRender: "isNull" },
        },
        {
          title: this.$t("lbl_price"),
          dataIndex: "price",
          key: "price",
          width: 75,
          scopedSlots: { customRender: "isCurrency" },
        },
        {
          title: this.$t("lbl_total"),
          dataIndex: "subtotal",
          key: "subtotal",
          width: 75,
          scopedSlots: { customRender: "isCurrency" },
        },
      ];
    },
  },

  methods: {
    toggleCustomer(customerName: string): void {
      const idx = this.collapsedCustomers.indexOf(customerName);
      if (idx !== -1) {
        this.collapsedCustomers.splice(idx, 1);
      } else {
        this.collapsedCustomers.push(customerName);
      }
    },
    toggleIc(icNo: string): void {
      const idx = this.collapsedIcs.indexOf(icNo);
      if (idx !== -1) {
        this.collapsedIcs.splice(idx, 1);
      } else {
        this.collapsedIcs.push(icNo);
      }
    },

    truncateCustomer(customer: string): string {
      if (customer.length >= 100) {
        return `${customer.slice(0, 100)}...`;
      }

      return customer;
    },

    formatStatus(value: EnumInvoiceArStatus) {
      if (!value) return "-";
      return value
        .toLowerCase()
        .split("_")
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    closePopupInvoiceDetail(): void {
      this.show.detailInvoice = false;
    },

    async openInvoice(line: InvoiceRecurringReportLine): Promise<void> {
      if (!line.invoiceArId) return;
      this.loadingDetail = true;
      try {
        const { findSummary } = useInvoiceAR();
        const res = await findSummary(line.invoiceArId);
        const data = {
          invoiceNumber: res.invoiceNo,
          invoiceDate: res.invoiceDate,
          taxType: res.taxType,
          top: res.top,
          currency: res.currency,
          poNumber: res.poNo,
          referenceNumber: res.reference,
          invoiceTaxNo: res.taxInvoiceNumber,
          customerName: res.customerName,
          shipTo: res.customerBillToAddress,
          usageType: res.usageType,
          description: res.description,
          subTotal: currencyFormat(res.subTotal),
          discount: currencyFormat(res.discount),
          taxBase: currencyFormat(res.taxBase),
          ppn: currencyFormat(res.ppn),
          grandTotal: currencyFormat(res.grandTotal),
          arLines: res.invoiceArLinePrintDTOList,
        };
        this.detailData = data;

        this.show.detailInvoice = true;
      } finally {
        this.loadingDetail = false;
      }
    },
  },
});
